document.addEventListener('DOMContentLoaded', function() {
  $('.slick-slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<span class="slick-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12.25L10.375 17.875M10.375 17.875L16 23.5M10.375 17.875H25.375M34.75 17.875C34.75 27.1949 27.1949 34.75 17.875 34.75C8.5552 34.75 1 27.1949 1 17.875C1 8.5552 8.5552 1 17.875 1C27.1949 1 34.75 8.5552 34.75 17.875Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.75 12.25L25.375 17.875M25.375 17.875L19.75 23.5M25.375 17.875H10.375M1 17.875C1 27.1949 8.55512 34.75 17.875 34.75C27.1948 34.75 34.75 27.1949 34.75 17.875C34.75 8.5552 27.1948 1 17.875 1C8.55512 1 1 8.5552 1 17.875Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });


$(".product__accordion details").each(function() {
  var $details = $(this);
 $(this).attr('open', true);
  // Function to update the accordion icon
  function updateIcon() {
    var isOpen = $details.attr("open") !== undefined;
    var $icon = $details.find(".accordion-icon path");

    // Check if the accordion is open
    if (isOpen) {
      // Change to minus icon
      $icon.attr("d", "M20 12.998H6V10.998H20V12.998Z");
    } else {
      // Change to plus icon
      $icon.attr("d", "M20 12.998H14V18.998H12V12.998H6V10.998H12V4.99805H14V10.998H20V12.998Z");
    }
  }

  // Initialize the correct icon on page load
  updateIcon();

  // Listen for changes (when accordion opens/closes)
  $details.on("toggle", function() {
    updateIcon();
  });
});

// banner custom link js
    $('.custm_link_url').each(function(){
        $(this).click(function(){
        var urlLink = $(this).find('.custm-link').attr('href');
        if (urlLink) {
                window.location.href = urlLink; 
            }
        });
    });
});



  let menus = document.querySelector(".header__inline-menu").querySelectorAll("details");
 
  menus.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });